import { FC } from 'react'

import styled, { css } from 'styled-components'

import { formatDate } from 'src/Constants/formatDate'
import dayJs from 'src/Helpers/dayjs'
import { MAX_MOBILE_WIDTH, MAX_TABLET_WIDTH } from 'src/Styled/variables'

const DESKTOP_WIDE = 1280

const tabletRange = css`
  @media (min-width: ${parseInt(MAX_MOBILE_WIDTH, 10) +
    2}px) and (max-width: ${MAX_TABLET_WIDTH}) {
    flex-direction: row;
    align-items: center;
  }
`

const tabletExactly767 = css`
  @media (min-width: 767px) and (max-width: 767px) {
    flex-direction: row;
    align-items: flex-start;
  }
`

const desktop1024to1279 = css`
  @media (min-width: ${parseInt(MAX_TABLET_WIDTH, 10) +
    1}px) and (max-width: ${DESKTOP_WIDE - 1}px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

const desktop1280plus = css`
  @media (min-width: ${DESKTOP_WIDE}px) {
    flex-direction: row;
    align-items: center;
  }
`

const StyledPerformanceOverviewTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  font-family: 'Segoe UI';
  font-style: normal;
  line-height: 150%;
  gap: 4px;
  color: ${({ theme }) => theme.color.darkGrey};

  ${tabletRange}
  ${tabletExactly767}
  ${desktop1024to1279}
  ${desktop1280plus}
`

const Title = styled.div`
  font-size: 20px;
  font-weight: 600;
  line-height: 150%;
`

const Text = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
`

interface PerformanceOverviewTitleProps {
  lastUpdatedAt?: string
}

export const PerformanceOverviewTitle: FC<PerformanceOverviewTitleProps> = ({
  lastUpdatedAt,
}) => {
  const formattedLastUpdatedAt = dayJs(lastUpdatedAt).format(
    formatDate.formatDateFirst3,
  )
  return (
    <StyledPerformanceOverviewTitle>
      <Title>Performance overview</Title>
      {Boolean(lastUpdatedAt) && (
        <Text>{`Last update: ${formattedLastUpdatedAt}`}</Text>
      )}
    </StyledPerformanceOverviewTitle>
  )
}
